<template>
  <div id="table_list">
    <div class="relativeItem top_area">
      <img class="zhuantop imgBlock noevents-img" src="../../assets/list/zhuantop.png" />
      <img class="navbar" src="../../assets/list/navbar.png" @click="goback" />
    </div>

    <!-- 列表主题区域 -->
    <div class="main">
      <!-- 居中的盒子 -->
      <div class="main_con">
        <ul class="uldiv flex-box">
          <li class="l1">头像</li>
          <li class="l2">昵称</li>
          <li class="l3">朱贝号</li>
          <li class="l4">奖品</li>
        </ul>
        <div v-if="user_pailist.length > 0">
          <ul class="paihang_list">
            <li class="p_item flex-box" v-for="(n, index) in user_pailist" :key="index">
              <div class="head">
                <img
                  class="imgBlock radius50 noevents-img"
                  :src="n.avatar"
                  onerror="this.src='http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
                />
              </div>
              <span class="s1 apostrophe">{{ n.nickname }}</span>
              <span class="s2">{{ n.usernumber }}</span>
              <div class="img_text flex-box">
                <img
                  class="noevents-img gift_img"
                  :src="n.giftimage"
                  onerror="this.src='http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
                />
                <i>{{ n.giftname }}</i>
              </div>
            </li>
          </ul>
          <!--加载更多-->
          <div class="show_more flex-box" v-if="user_pailist_more" @click="get_more_phb">
            <span>加载更多</span>
            <img class="noevents-img imgBlock" src="../../assets/more_arrow.png" />
          </div>
        </div>

        <div class="no-records" v-else>
          <img src="../../assets/tablegame (5).png" />
          暂无数据
        </div>
      </div>
    </div>
  </div>
</template>












<script>
export default {
  data() {
    return {
      user_pailist: [], //排行榜列表数据
      p_phb_page: 1,
      user_pailist_more: true,
    };
  },
  mounted() {
    this.$tool.setTitle("中奖榜单");
    this.get_phb();
  },
  methods: {
    goback() {
      this.$appAc.closeWeb();
    },

    //获取排行榜数据
    get_phb() {
      let data = {
        page: this.p_phb_page,
        pagesize: 9,
      };
      let _this = this;
      this.$jsonp(this.$apis("turn_table_phb", "app"), data, (res) => {
        let ls = res.data.data.data;
        if (ls.length > 0) {
          _this.user_pailist = _this.user_pailist.concat(ls);
        } else {
          _this.user_pailist_more = false;
        }
      });
    },

    // 点击加载更多
    get_more_phb() {
      this.p_phb_page++;
      this.get_phb();
    },
  },
};
</script>










<style scoped lang="scss">
#table_list {
  width: 100%;
  min-height: 100vh;
}
// 顶部导航区域
.top_area {
  .zhuantop {
    width: 100%;
  }
  .navbar {
    position: fixed;
    width: 12px;
    left: 26px;
    top: 53px;
  }
}

// 列表排行区域
.main {
  width: 100%;
  background-color: #7e4ffe;
  padding-bottom: 50px;
  padding-top: 10px;
}

.main_con {
  width: 86%;
  background-color: #fff;
  margin: 0 auto;
}
.uldiv {
  width: 100%;
  background-color: #6215c3;
  border: 1px solid #a47ceb;
  padding: 6px 8%;
}
.uldiv .l2,
.l3 {
  margin-left: 15%;
}
.l4 {
  margin-left: 20%;
}
.uldiv li {
  color: #fffc00;
  font-size: 12px;
}

// 列表的样式
.paihang_list {
  min-height: 585px;
  max-height: 600px;
  overflow-y: scroll;
}
.p_item {
  align-items: center;
  height: 65px;
  padding: 6px 0;
  padding-left: 20px;
  background-color: #7032e0;
  border: 1px solid #a47ceb;
  border-top: transparent;
}
.head {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  overflow: hidden;
}
.s1 {
  width: 20%;
  text-align: center;
  color: #fff;
  font-size: 12px;
  margin-left: 20px;
}
.s2 {
  width: 25%;
  text-align: center;
  color: #fced2f;
  font-size: 12px;
  font-weight: bold;
}
.img_text {
  width: 35%;
  font-size: 10px;
  color: #999;
  align-items: center;
}
i {
  font-style: normal;
}
.img_text * {
  vertical-align: middle;
}
.gift_img {
  max-width: 37%;
  margin-left: 2px;
  margin-right: 5px;
}
// 加载更多
.show_more {
  background-color: #6016c3;
  font-size: 12px;
  color: white;
  justify-content: center;
  align-items: center;
  padding: 6px 0;
  border: 1px solid #a47ceb;
  border-top: transparent;
  * {
    vertical-align: middle;
  }
  img {
    width: 12px;
    height: 12px;
    margin-left: 4px;
  }
}
.no-records {
  text-align: center;
  padding-top: 10rem;
  padding-bottom: 2rem;
  font-size: 14px;
  color: #666;
  width: 100%;
  background-color: #6215c3;
  border: 1px solid #a47ceb;
  border-top: transparent;
  min-height: 50vh;
  img {
    display: block;
    margin: 0 auto;
    margin-bottom: 5px;
    width: 2.125rem;
  }
}
</style>